import { t } from '../../../i18n.es.js';
import { styled, Currency, LazyImage, SvgIcon, Button } from '@teko/ui';
import React from 'react';
import { ProductPrice } from '../../../Common/ProductPrice/ProductPrice.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div`
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  padding: 16px;
`;
const Images = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
const Image = styled.div`
  width: 60px;
  height: 60px;
`;
const Overlay = styled(Image)`
  border-radius: 4px;
  color: #b4b4b4;
  background-color: #f6f6f6;

  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Text = styled.div`
  font-size: 0.625rem;
`;
const Retangle = styled.div`
  margin: 16px auto;
  position: relative;
  display: block;
  text-align: center;

  &::before {
    content: '';
    top: 10px;
    left: 0;
    width: 100%;
    height: 1px;

    border-radius: 2px;
    background-color: #d6dde4;
    display: inline-block;
    position: absolute;
  }

  span {
    color: #848788;
    background-color: #fff;
    padding: 0 10px;
    font-size: 10px;
    line-height: 1.6;
    text-transform: uppercase;

    position: relative;
    display: inline-block;
    border: solid 1px #e0e0e0;
  }
`;
const PriceInfo = styled.div`
  margin-bottom: 4px;
  display: flex;
  flex-direction: column;
`;
const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const SavePrice = styled.span`
  margin-left: 4px;
  span {
    color: #eb2101;
    font-weight: bold;
  }
`;
const Footer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const ViewDetail = styled.a`
  color: #047fff;
  cursor: pointer;
  text-decoration: none;
`;
const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
`;
const StyledConcurrency = styled(Currency)`
  margin-left: 4px;
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
const StyledProductPrice = styled(ProductPrice)`
  margin-left: 4px;
`;
const ProductCombo = (_a) => {
  var _b = _a, {
    productCombo,
    className,
    linkDetail = "",
    linkBuy = ""
  } = _b, props = __objRest(_b, [
    "productCombo",
    "className",
    "linkDetail",
    "linkBuy"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({
    className
  }, props), /* @__PURE__ */ React.createElement(Images, null, productCombo.images.slice(0, 3).map((image, index) => {
    if (productCombo.bundleProduct && productCombo.bundleProduct.length > 3) {
      if (index == 2) {
        return /* @__PURE__ */ React.createElement(Overlay, {
          key: index
        }, /* @__PURE__ */ React.createElement("div", null, productCombo.bundleProduct.length - 2, " "), /* @__PURE__ */ React.createElement(Text, null, t("s\u1EA3n ph\u1EA9m")));
      }
    }
    return /* @__PURE__ */ React.createElement(ImageWrapper, {
      key: index
    }, /* @__PURE__ */ React.createElement(Image, null, /* @__PURE__ */ React.createElement(LazyImage, {
      contain: true,
      src: image.src,
      width: 60,
      height: 60
    })), index !== productCombo.images.length - 1 && /* @__PURE__ */ React.createElement(SvgIcon, {
      name: "plus-default",
      size: 16,
      color: "#848788"
    }));
  })), /* @__PURE__ */ React.createElement(Retangle, null, /* @__PURE__ */ React.createElement("span", null, t("Ch\u1EC9 c\xF2n"))), /* @__PURE__ */ React.createElement(PriceInfo, null, productCombo.price.price && /* @__PURE__ */ React.createElement(PriceWrapper, null, /* @__PURE__ */ React.createElement(IconWrapper, null, /* @__PURE__ */ React.createElement(SvgIcon, {
    name: "cash-outline",
    size: 16,
    color: "green"
  })), /* @__PURE__ */ React.createElement(StyledProductPrice, {
    price: productCombo.price.price,
    listedPrice: productCombo.price.listedPrice,
    horizontal: true
  })), productCombo.price.listedPrice && /* @__PURE__ */ React.createElement(PriceWrapper, null, /* @__PURE__ */ React.createElement(IconWrapper, null, /* @__PURE__ */ React.createElement(SvgIcon, {
    name: "promotion-fill",
    size: 16,
    color: "red"
  })), /* @__PURE__ */ React.createElement(SavePrice, null, t("Ti\u1EBFt ki\u1EC7m:"), /* @__PURE__ */ React.createElement(StyledConcurrency, {
    value: productCombo.price.listedPrice - productCombo.price.price
  })))), /* @__PURE__ */ React.createElement(Footer, null, /* @__PURE__ */ React.createElement(ViewDetail, {
    href: linkDetail
  }, t("Xem chi ti\u1EBFt")), /* @__PURE__ */ React.createElement(Button, {
    variant: "primary",
    outline: true,
    link: true,
    href: linkBuy
  }, "Mua ngay")));
};

export { ProductCombo };
